import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';

/**
 * Vehicle insurance claim record DTO
 */
@CaslSubject(AppSubjectEnum.VEHICLE_INSURANCE_CLAIM)
export class VehicleInsuranceClaimRecordDto extends BaseDto {
	notes?: string;
	files?: FileDto[];
}
